module.exports = __webpack_public_path__ + "static/media/jumbo_banner_4.ba732442.jpg";